import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ContextMenuService {
    public show = new Subject<any>();
}



// WEBPACK FOOTER //
// ./src/common/context-menu/context-menu.service.ts